import { createStore } from 'vuex'
import { faChartBar, faChartLine, faIdBadge, faMoneyBillTransfer, faStore, faStoreAlt, faUsers } from '@fortawesome/free-solid-svg-icons'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { Role } from '@/enums/Roles.enum'

interface IUser {
    name: string;
    email: string;
    cnpj: string;
    system: string;
    type: string;
    active: boolean;
    nomeFantasia: string;
    avatarImage?: string;
}

interface ISidebarMenu {
  name: string;
  route: string;
  disabled?: boolean;
  hidden?: boolean;
  textColor?: string;
  icon?: IconDefinition;
  iconCustomClass?: string;
}

interface IState {
  token: string;
  user: IUser;
  softwareHouse: Record<string, unknown>;
  sidebarMenu: ISidebarMenu[];
  sidebarActive: number;
  isSidebarCollapsed: boolean;
}

export default createStore<IState>({
  state: {
    token: '',
    softwareHouse: {},
    user: {
      name: '',
      email: '',
      cnpj: '',
      system: '',
      type: '',
      active: false,
      nomeFantasia: ''
    },
    sidebarMenu: [
      {
        name: 'Painel',
        icon: faChartBar,
        iconCustomClass: 'text-white text-center',
        route: '/painel',
        hidden: false
      },
      {
        name: 'Software Houses',
        icon: faStoreAlt,
        iconCustomClass: 'text-white text-center',
        route: '/software-houses',
        hidden: true
      },
      {
        name: 'Estabelecimentos',
        icon: faStore,
        iconCustomClass: 'text-white text-center',
        route: '/estabelecimentos'
      },
      {
        name: 'Volumetria',
        icon: faChartLine,
        iconCustomClass: 'text-white text-center',
        route: '/volumetria',
        hidden: false
      },
      {
        name: 'Comissões',
        icon: faMoneyBillTransfer,
        iconCustomClass: 'text-white text-center',
        route: '/comissoes',
        hidden: false
      },
      {
        name: 'Aprovações',
        icon: faMoneyBillTransfer,
        iconCustomClass: 'text-white text-center',
        route: '/aprovacoes',
        hidden: true
      },
      {
        name: 'Dados Cadastrais',
        icon: faIdBadge,
        iconCustomClass: 'text-white text-center',
        route: '/dados',
        hidden: false
      },
      {
        name: 'Usuários',
        icon: faUsers,
        iconCustomClass: 'text-white text-center',
        route: '/usuarios',
        hidden: true
      }
      // {
      //   name: 'Planos Comerciais',
      //   icon: faClipboardList,
      //   iconCustomClass: 'text-white text-center',
      //   route: '/planos',
      //   hidden: false
      // },
      // {
      //   name: 'Planos Disponiveis',
      //   icon: faClipboardList,
      //   iconCustomClass: 'text-white text-center',
      //   route: '/planos-disponiveis',
      //   hidden: false
      // }
    ],
    sidebarActive: 0,
    isSidebarCollapsed: false
  },
  mutations: {
    changeActiveMenu (state, menuIndex: number) {
      state.sidebarActive = menuIndex
    },
    hidePainelMenu (state, hidden: boolean) {
      state.sidebarMenu[0].hidden = hidden
    },
    hideSoftwareHousesMenu (state, hidden: boolean) {
      state.sidebarMenu[1].hidden = hidden
    },
    hideEstablishmentsMenu (state, hidden: boolean) {
      state.sidebarMenu[2].hidden = hidden
    },
    hideVolumetryMenu (state, hidden: boolean) {
      state.sidebarMenu[3].hidden = hidden
    },
    hideCommissionMenu (state, hidden: boolean) {
      state.sidebarMenu[4].hidden = hidden
    },
    hideApprovalMenu (state, hidden: boolean) {
      state.sidebarMenu[5].hidden = hidden
    },
    hideProfileMenu (state, hidden: boolean) {
      state.sidebarMenu[6].hidden = hidden
    },
    hideUsersMenu (state, hidden: boolean) {
      state.sidebarMenu[7].hidden = hidden
    },
    collapseSidebar (state, isCollapsed: boolean) {
      state.isSidebarCollapsed = isCollapsed
    },
    populateToken (state, token) {
      state.token = token
    },
    populateUser (state, user) {
      state.user = user
    },
    populateUserImageProfie (state, image) {
      state.user.avatarImage = image
    },
    populateSoftwareHouse (state, softwareHouse) {
      state.softwareHouse = softwareHouse
    },
    isApprovalUser (state) {
      return state.user.type === Role.APROVACAO
    },
    resetData (state) {
      state.token = ''
      state.user = {
        name: '',
        email: '',
        cnpj: '',
        system: '',
        type: '',
        active: false,
        nomeFantasia: '',
        avatarImage: undefined
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
